<template>
  <div class="row main-content">
    <SocialBar/>
    <CreditoSimpleOSComponent/>
  </div>
</template>

<script>
import CreditoSimpleOSComponent from './components/CreditoSimpleOSComponent.vue';
import SocialBar from './components/SocialBar.vue';


export default {
  name: 'CreditoSimpleOS',
  components: {
    SocialBar,
    CreditoSimpleOSComponent
  }
}

</script>